import { FelaCSS, FelaCSSWithCustomSelectors } from '@bridebook/ui';

export interface IStyles {
  font: FelaCSS;
  wrapperStyle: FelaCSSWithCustomSelectors;
}

export const styles: IStyles = {
  font: {
    fontFamily: 'var(--font-body-typeface)',
  },
  wrapperStyle: {
    ':focus-within': { border: `1px solid var(--ww-palette-cta-active)` },
  },
};
